












































































import { namespace } from 'vuex-class';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { complexClone } from '@acgn/herm/src/util/serialize';

export interface FieldEditType { // 编辑结构类型
  operate: number; // 操作符
  value: number | null; // 差异值
  originValue: number | null; // 原值
  remark: string; // 备注
}

@Component({
  components: {
    AcgnPop
  }
})

/**
 * 项目明细字段修改-公共弹窗
 */
export default class AcgnPopFiledModify extends Vue {
  public name: string = 'AcgnPopFiledModify';

  @Prop({ default: 0 }) public num: number; // 小数点位数
  @Prop({ default: false }) public visible: boolean; // 可视
  @Prop({ default: () => { } }) public submit: any; // 提交方法

  // 数据
  @Prop({
    type: Object, default: () => ({
      title: 'title', field: 'field', type: null,
      operate: 1, value: null, originValue: null
    })
  }) private data: object;

  // private show = false; // 是否显示弹窗
  get show() {
    return this.visible;
  }
  set show(v) {
    this.$emit('update:visible', v);
  }

  private operates = [{ key: '+', value: 0 }, { key: '-', value: 1 }];
  private formData: FieldEditType = {
    operate: 0,
    originValue: 0,
    value: null,
    remark: ''
  };

  get finalValue() {
    const originValue: any = this.formData.originValue;
    const diffValue: any = this.formData.value || 0;
    let re: any = 0;
    if (this.formData.operate === 0) {
      re = originValue + diffValue;
    }
    if (this.formData.operate === 1) {
      re = originValue - diffValue;
    }
    const domNum: any = re.toString().split('.');
    if (domNum[1] && domNum[1].length > this.num) {
      re = re.toFixed(this.num);
    }
    return re;
  }

  // 验证信息监听
  @Watch('data', { immediate: true })
  private dataChange() {
    this.initData();
    this.formData = { ...this.formData, ...this.data };
    const tempValue: any = this.formData.value;
    if (tempValue) {
      this.formData.operate = tempValue < 0 ? 1 : 0;
      this.formData.value = Math.abs(tempValue);
    }
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      value: [
        { required: true, message: '请输入数值', trigger: 'blur' },
        { validator: this.validateNum, trigger: 'blur' }
      ]
    };
    return rules;
  }

  private initData() {
    this.formData = {
      operate: 0,
      originValue: 0,
      value: null,
      remark: ''
    };
  }

  // 校验数值规则
  private validateNum(rules: any, value: string, callback: any) {
    if (!this.formData.value) {
      callback(new Error('请输入非空数值'));
      return;
    }
    callback();
  }

  // 取消
  private close() {
    this.show = false;
  }

  private async submitOk() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const dataClone = complexClone(this.formData);
        dataClone.value = dataClone.operate === 1 ? -dataClone.value : dataClone.value;
        if ((this as any).data.value === dataClone.value) {
          this.$message.warning('修正值无变化');
          return;
        }
        dataClone.revised_extra =
          `${dataClone.originValue}${dataClone.operate === 0 ? '+' : '-'}${dataClone.value} = ${this.finalValue}`;
        this.show = await this.submit(dataClone);
      } catch (ex) {
        this.$message.error(this.$language.error);
      }
    });
  }
}
